export const downloadFile = (fileName: string, encodedUri: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('href', encodedUri);
    downloadLink.setAttribute('download', fileName);

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
};

export const downloadFileFromResponse = async (response: Response) => {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition?.split('filename=')[1]?.replace(/['"]/g, '');
    if (!filename) {
        throw new Error('Failed to download file, filename is missing from the response headers');
    }
    downloadFile(filename, window.URL.createObjectURL(await response.blob()));
};
